export const FLUTTERWAVE_COUNTRIES = [
  "NG", // Nigeria
  "GH", // Ghana
  "KE", // Kenya
  "UG", // Uganda
  "RW", // Rwanda
  "ZM", // Zambia
  "TZ", // Tanzania
  "ZA", // South Africa
  "EG", // Egypt
  "BF", // Burkina Faso (XOF)
  "CI", // Ivory Coast (XOF)
  "SN", // Senegal (XOF)
  "CM", // Cameroon (XAF)
];
